import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './About.css';
import useLanguage from '../hooks/useLanguage';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="about-section py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h2 className="display-5 fw-bold text-dark mb-3">{t('about', 'title')}</h2>
            <p className="lead text-muted">
              {t('about', 'subtitle')}
            </p>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-6 mb-4">
            <div className="about-content" data-aos="fade-up">
              <h3 className="fw-bold text-dark mb-4">{t('about', 'whoWeAre')}</h3>
              <p className="lead mb-4" dangerouslySetInnerHTML={{ __html: t('about', 'whoWeAreParagraph1') }} />
              <p className="lead mb-4">
                {t('about', 'whoWeAreParagraph2')}
              </p>

              <div className="about-features">
                <div className="feature-item">
                  <i className="bi bi-award text-primary"></i>
                  <span>{t('about', 'featureExperience')}</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-people text-primary"></i>
                  <span>{t('about', 'featureTeam')}</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-globe text-primary"></i>
                  <span>{t('about', 'featureGlobal')}</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-shield-check text-primary"></i>
                  <span>{t('about', 'featureQuality')}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-stats" data-aos="fade-up">
              <div className="row g-4">
                <div className="col-6">
                  <div className="stat-card">
                    <div className="stat-number">200+</div>
                    <div className="stat-label">{t('about', 'statClients')}</div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-card">
                    <div className="stat-number">5+</div>
                    <div className="stat-label">{t('about', 'statYears')}</div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-card">
                    <div className="stat-number">2</div>
                    <div className="stat-label">{t('about', 'statCountries')}</div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-card">
                    <div className="stat-number">24/7</div>
                    <div className="stat-label">{t('about', 'statSupport')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-12">
            <div className="mission-vision">
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="mission-card" data-aos="fade-up">
                    <div className="card-icon">
                      <i className="bi bi-bullseye"></i>
                    </div>
                    <h4>{t('about', 'missionTitle')}</h4>
                    <p>
                      {t('about', 'missionText')}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="vision-card" data-aos="fade-up" data-aos-delay="200">
                    <div className="card-icon">
                      <i className="bi bi-eye"></i>
                    </div>
                    <h4>{t('about', 'visionTitle')}</h4>
                    <p>
                      {t('about', 'visionText')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
